import { render } from "./finalist-in-livia.vue?vue&type=template&id=39ad4a4b&scoped=true"
import script from "./finalist-in-livia.vue?vue&type=script&lang=js"
export * from "./finalist-in-livia.vue?vue&type=script&lang=js"

import "./finalist-in-livia.vue?vue&type=style&index=0&id=39ad4a4b&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ad4a4b"]])

export default __exports__